var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "divBox bill-type" },
        [
          _c("div", { staticClass: "title" }, [_vm._v("动态列表")]),
          _vm._v(" "),
          _c("el-form", { attrs: { inline: true } }, [
            _c(
              "div",
              { staticClass: "flex" },
              [
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "grey-bg",
                      staticStyle: {
                        border: "none",
                        "margin-left": "0",
                        width: "150px",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            size: "small",
                            placeholder: _vm.$t("finance.pleaseselect"),
                          },
                          model: {
                            value: _vm.type,
                            callback: function ($$v) {
                              _vm.type = $$v
                            },
                            expression: "type",
                          },
                        },
                        _vm._l(_vm.typesOptions, function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-form-item", [
                    _c("span", { staticClass: "num" }, [
                      _vm._v(
                        "共 " +
                          _vm._s(
                            _vm.type == 1 ? _vm.projectTotal : _vm.taskTotal
                          ) +
                          " 项"
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { staticClass: "select-bar" },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          size: "small",
                          type: "daterange",
                          clearable: "",
                          format: "yyyy/MM/dd",
                          "value-format": "yyyy/MM/dd",
                          "range-separator": _vm.$t("toptable.to"),
                          "start-placeholder": _vm.$t("toptable.startdate"),
                          "end-placeholder": _vm.$t("toptable.endingdate"),
                        },
                        on: { change: _vm.selectChange },
                        model: {
                          value: _vm.timeVal,
                          callback: function ($$v) {
                            _vm.timeVal = $$v
                          },
                          expression: "timeVal",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { staticClass: "select-bar" },
                    [
                      _c("select-member", {
                        staticClass: "mr10",
                        staticStyle: { width: "200px" },
                        attrs: {
                          value: _vm.userList || [],
                          "is-search": true,
                          placeholder: "请选择操作人",
                        },
                        on: { getSelectList: _vm.getSelectList },
                      }),
                    ],
                    1
                  ),
                ],
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          effect: "dark",
                          content: "重置搜索条件",
                          placement: "top",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "reset", on: { click: _vm.reset } },
                          [_c("i", { staticClass: "iconfont iconqingchu" })]
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.type == 1 ? _vm.projectList : _vm.taskList,
                    "row-key": "id",
                    "tooltip-effect": "dark",
                    "header-cell-style": { background: "#f7fbff" },
                    "row-class-name": _vm.iconHadler,
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "created_at",
                      label: "操作时间",
                      "min-width": "150",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "operator",
                      label: "操作人",
                      "min-width": "100",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "title",
                      label: "操作说明",
                      "min-width": "600",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", {
                              domProps: { innerHTML: _vm._s(scope.row.title) },
                            }),
                            _vm._v(" "),
                            _vm.type == 2 && scope.row.task
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "pointer click-info",
                                    on: {
                                      click: function ($event) {
                                        return _vm.taskInfo(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              #" +
                                        _vm._s(scope.row.task.ident) +
                                        " " +
                                        _vm._s(scope.row.task.name) +
                                        "（点击可查看详情）\n            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _vm.type == 1
                    ? _c("el-table-column", {
                        attrs: { type: "expand" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return scope.row.describe.length
                                  ? [
                                      scope.row.describe.length > 0
                                        ? _c(
                                            "div",
                                            { staticClass: "program-box" },
                                            _vm._l(
                                              scope.row.describe,
                                              function (item) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: item.id,
                                                    staticClass:
                                                      "flex program-describe",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      { staticClass: "titles" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(item.title)
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(item.value)
                                                      ),
                                                    ]),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : _vm._e(),
                                    ]
                                  : undefined
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.type == 2
                    ? _c("el-table-column", {
                        attrs: { type: "expand" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("div", { staticClass: "program-box" }, [
                                    scope.row.describe.length > 0
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "flex expand-describe",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "flex expand-left",
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      scope.row.describe[0]
                                                        .title
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("p", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      scope.row.describe[0]
                                                        .value
                                                    ),
                                                  },
                                                }),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("div", {
                                              staticClass: "line-short",
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "flex expand-right",
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      scope.row.describe[1]
                                                        .title
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("p", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      scope.row.describe[1]
                                                        .value
                                                    ),
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1442247777
                        ),
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "paginationClass" },
            [
              _c("el-pagination", {
                attrs: {
                  "page-size":
                    _vm.type == 1 ? _vm.projectForm.limit : _vm.taskForm.limit,
                  "current-page":
                    _vm.type == 1 ? _vm.projectForm.page : _vm.taskForm.page,
                  "page-sizes": [10, 15, 20],
                  layout: "total, prev, pager, next, jumper",
                  total: _vm.type == 1 ? _vm.projectTotal : _vm.taskTotal,
                },
                on: {
                  "size-change": function ($event) {
                    return _vm.handleSizeChange(_vm.type, $event)
                  },
                  "current-change": function ($event) {
                    return _vm.pageChange(_vm.type, $event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("addTask", {
        ref: "addTask",
        attrs: {
          projectList: _vm.projectInfoList,
          programOptions: _vm.programOptions,
          programMemberOptions: _vm.programMemberOptions,
          programVersionList: _vm.programVersionList,
        },
        on: {
          getMemberList: _vm.getMemberList,
          getProgramVersionList: _vm.getProgramVersionList,
          getProgramSelectList: _vm.getProgramSelectList,
          getTableData: function ($event) {
            return _vm.getTableData()
          },
        },
      }),
      _vm._v(" "),
      _c("editTask", {
        ref: "editTask",
        attrs: {
          projectList: _vm.projectInfoList,
          programOptions: _vm.programOptions,
          programMemberOptions: _vm.programMemberOptions,
          programVersionList: _vm.programVersionList,
        },
        on: {
          getMemberList: _vm.getMemberList,
          getProgramVersionList: _vm.getProgramVersionList,
          getProgramSelectList: _vm.getProgramSelectList,
          getTableData: function ($event) {
            return _vm.getTableData()
          },
          openTask: _vm.openTask,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }